<template>
  <footer>
    <div :class="`footer__area ${footerBgTwo ? 'grey-bg-2' : 'footer-bg'}`">
      <div :class="`footer__top ${footerPadding ? 'pt-90' : 'pt-190'} pb-40`">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="footer__widget mb-30">
                <div class="footer__widget-head mb-10">
                  <div class="footer__logo text-center">
                    <router-link to="/"
                      ><img
                        width="100"
                        height="100"
                        src="../../assets/img/logotip1.png"
                        alt=""
                    /></router-link>
                  </div>
                </div>
                <div
                  :class="`${
                    footerBgTwo
                      ? 'footer__widget-body-2'
                      : 'footer__widget-body'
                  }`"
                >
                  <h4 style="color: white; text-align: center">
                    Togʻ-kon va geologiya <br />
                    sohasi xodimlari <br />
                    malakasini oshirish <br />
                    instituti
                    <!-- {{$t('about.companyName')}} -->
                  </h4>
                  <div class="d-none footer__social text-center mt-25">
                    <ul>
                      <li>
                        <a href="#"><i class="fab fa-facebook-f"></i></a>
                      </li>
                      <li>
                        <a href="#" class="tw"
                          ><i class="fab fa-twitter"></i
                        ></a>
                      </li>
                      <li>
                        <a href="#" class="pin"
                          ><i class="fab fa-pinterest-p"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="contact__info-inner pt-0 px-0">
                <h3 class="mb-30 mt-20 pl-30" style="color: white">
                  {{ $t("navbar.contact") }}
                </h3>
                <ul class="pl-30">
                  <li>
                    <div
                      class="contact__info-item d-flex align-items-start mb-20"
                    >
                      <div class="contact__info-text d-flex align-items-center">
                        <img
                          width="25"
                          src="@/assets/img/banner/pin.png"
                          alt=""
                        />
                        <p style="color: white; padding-left: 10px">
                          <a
                            target="_blank"
                            href="https://maps.google.com/maps?q=41.299517,69.148703&ll=41.299517,69.148703&z=16"
                          >
                            Toshkent shahar Uchtepa tumani TXAY ko'chasi 5-uy
                          </a>
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      class="contact__info-item d-flex align-items-start mb-20"
                    >
                      <div class="contact__info-text d-flex align-items-center">
                        <img
                          width="25"
                          src="@/assets/img/banner/phone-call.png"
                          alt=""
                        />
                        <div class="d-block">
                          <p style="color: white; padding-left: 10px">
                            <a href="tel:+998-(90)-015-60-50"
                              >+998 (90) 015 60 50</a
                            >
                          </p>
                          <p style="color: white; padding-left: 10px">
                            <a href="tel:+998-(91)-019-08-99"
                              >+998 (91) 019 08 99</a
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      class="contact__info-item d-flex align-items-start mb-20"
                    >
                      <div class="contact__info-text d-flex">
                        <img
                          width="25"
                          src="@/assets/img/banner/arroba.png"
                          alt=""
                        />
                        <p style="color: white; padding-left: 10px">
                          <a href="mailto:geomalaka@exat.uz"
                            >geomalaka@exat.uz</a
                          >
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-5 col-md-4 col-sm-6 col-12">
              <div class="mapouter">
                <div class="gmap_canvas">
                  <iframe
                    style="
                      border: 0;
                      max-width: 500px;
                      width: 100%;
                      height: 260px;
                      border-radius: 8px;
                    "
                    id="gmap_canvas"
                    class="gmap_iframe"
                    frameborder="0"
                    scrolling="no"
                    marginheight="0"
                    marginwidth="0"
                    src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=Geologiya tarmog'i xodimlari malakasini oshirish va qayta tayyorlash instituti&amp;t=k&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      <div :class="`${footerBgTwo ? 'footer__bottom footer__bottom-2' : 'footer__bottom'}`">-->
      <!--         <div class="container">-->
      <!--            <div class="row">-->
      <!--               <div class="col-xxl-12">-->
      <!--                  <div :class="`${footerBgTwo ? 'footer__copyright-2 text-center' : 'footer__copyright text-center'}`">-->
      <!--                     <p>© 2025 RTAM, All Rights Reserved.</p>-->
      <!--                  </div>-->
      <!--               </div>-->
      <!--            </div>-->
      <!--         </div>-->
      <!--      </div>-->
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterArea",
  props: {
    footerBgTwo: String,
    footerPadding: String,
  },
};
</script>
<style lang="scss" scoped>
.mapouter {
  position: relative;
}

.gmap_canvas {
  overflow: hidden;
  background: none !important;
}
</style>
